module.exports = __webpack_public_path__ + "media/images/story/typo/congratsResort-fcc767a122232611c6dd97d9e692aa43.svg";